import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../App";
import { MessageCircle, X } from "lucide-react";

export default function AskAFriendNudge() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [dismissed, setDismissed] = useState(false);

  // Hide on ask-related pages or if dismissed
  const hiddenPaths = ["/ask", "/askafriend", "/admin", "/login", "/auth"];
  if (dismissed || hiddenPaths.some(p => location.pathname.startsWith(p))) return null;

  const handleClick = () => {
    // Route unauthenticated users to the Zeel-branded login screen, not Auth0 Universal Login.
    if (!user) { navigate("/login?redirect=/askafriend"); return; }
    navigate("/askafriend");
  };

  return (
    <div className="fixed bottom-5 right-5 z-40" data-testid="ask-friend-nudge">
      <div
        className="relative bg-white rounded-2xl shadow-lg border border-slate-200 px-4 py-3 flex items-center gap-3 cursor-pointer hover:shadow-xl transition-shadow max-w-[260px] group"
        onClick={handleClick}
      >
        <button
          onClick={(e) => { e.stopPropagation(); setDismissed(true); }}
          className="absolute -top-2 -right-2 w-5 h-5 rounded-full bg-slate-100 hover:bg-slate-200 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
          data-testid="nudge-dismiss-btn"
          aria-label="Dismiss"
        >
          <X className="w-3 h-3 text-slate-500" />
        </button>
        <div className="w-9 h-9 rounded-xl flex items-center justify-center shrink-0" style={{ background: 'linear-gradient(135deg, #4A55A6, #6B5BA8)' }}>
          <MessageCircle className="w-4.5 h-4.5 text-white" />
        </div>
        <div className="min-w-0">
          <p className="text-sm font-semibold text-foreground leading-tight">Ask a Friend</p>
          <p className="text-xs text-muted-foreground leading-tight mt-0.5">Get routine help from the community</p>
        </div>
      </div>
    </div>
  );
}
